'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isError = isError;

var _isAction = require('./isAction');

function isError(action) {
    return (0, _isAction.isAction)(action) ? action.error === true : false;
}
//# sourceMappingURL=isError.js.map


// WEBPACK FOOTER //
// ./node_modules/@zaibot/fsa/es5/isError.js